import { Transition, Transitions, TransitionType } from 'types/Transitions';

export const findTransitionById = (
  items: Transitions['list'],
  transitionId: Transition['id'] | null
): Transition => {
  return transitionId
    ? items.find(({ id }) => id === transitionId)
    : items.find(({ type }) => type === TransitionType.None);
};
